import React from 'react';
import LinkIcon from '../../../../assets/icons/LinkIcon';
import {TShow} from '../../../../hooks/useShow';
import SheetShell from '../SheetShell/SheetShell';
import * as css from './LinkSheet.css';

export interface SheetLink {
    key: string;
    label: string;
    value?: string;
    href: string;
    icon: React.ReactNode;
    external?: boolean;
}

interface LinkSheetProps {
    show: TShow;
    title: string;
    links: SheetLink[];
    showArrow?: boolean;
    'data-cy'?: string;
}

function LinkSheet({show, title, links, showArrow, 'data-cy': dataCy = 'link-sheet'}: LinkSheetProps): React.ReactElement {
    const handleSelect = (href: string, external?: boolean) => (e: React.MouseEvent) => {
        e.preventDefault();
        if(external)
            window.open(href, '_blank', 'noopener,noreferrer');
        else
            window.location.href = href;
        show.close(e);
    };

    return (
        <SheetShell show={show} title={title} data-cy={dataCy}>
            <css.list>
                {links.map(({key, label, value, href, icon, external}) => (
                    <css.row
                        key={key}
                        href={href}
                        target={external ? '_blank' : undefined}
                        rel={external ? 'noopener noreferrer' : undefined}
                        onClick={handleSelect(href, external)}
                        data-cy={`${dataCy}-${key}`}
                    >
                        <css.rowIcon>{icon}</css.rowIcon>
                        <css.rowLabel>{label}</css.rowLabel>
                        {value && <css.rowValue dir="ltr">{value}</css.rowValue>}
                        {showArrow && <css.rowArrow><LinkIcon color="currentColor" width={18} height={18} /></css.rowArrow>}
                    </css.row>
                ))}
            </css.list>
        </SheetShell>
    );
}

export default LinkSheet;
